import { AxiosRequestConfig } from "axios";

import { getInstance } from "./instance";

const api = <T = any>(config: AxiosRequestConfig) => getInstance()<T>(config).then((res) => res.data);

export default api;
